<template>
  <div class="appointment-calendar-container">
    <!-- 顶部搜索栏 -->
    <div style="display: flex;justify-content: space-between;">
      <div class="calendar-header">
          <el-date-picker
              v-model="selectedDate"
              type="date"
              :clearable="false"
              placeholder="选择日期"
              class="date-picker"
              :value-format="'yyyy-MM-dd'"
              size="small"
            />
            <el-select v-model="shop_id" filterable placeholder="请输入" class="w120" v-if="!userInfo.shop_id" size="small">
              <el-option v-for="item in shopOptionsList" :key="item.shopId" :label="item.shopName" 
                :value="item.shopId" />
            </el-select>

            <el-button 
              type="primary" 
              icon="el-icon-search" 
              @click="handleDateSearch"
              size="small"
              class="search-btn"
            >
              搜索
            </el-button>
            <el-button 
              type="primary" 
              icon="el-icon-plus" 
              @click="openAppointDialog"
              class="add-appoint-btn"
              size="small"
              :disabled="!hasValidCounselor"
            >
              新增预约/备注
            </el-button>
            <el-button 
              type="primary" 
              size="small"
              plain
              icon="el-icon-refresh"
              @click="handleDateSearch"
            >
              刷新
            </el-button>
      </div>
    
      <div>
        <div 
          v-for="item in statusTags" 
          :key="item.text" 
          class="status-tag"
        >
          <div 
            class="color-block" 
            :style="{ backgroundColor: item.color }"
          ></div>
          <span class="status-text">{{ item.text }}</span>
        </div>
      </div>
    </div>
    <div class="table_box" >
      <div class="table_tile">工作时间规划表</div>
      <div @click="openSlogan" v-html="workTimeConfig.slogan" v-if="workTimeConfig.slogan"></div>
    </div>

    <!-- 日历主体 -->
    <div class="calendar-body">
      <FullCalendar 
        ref="fullCalendar" 
        :options="calendarOptions" 
        class="demo-app-calendar" 
        v-loading="isLoading"
      />
    </div>
    <div class="table_box">
      <div>营业时间:9:30-18:30</div>
      <div>为了节约您和他人的宝贵时间，请按照预约时间到店，谢谢合作!</div>
      <div style="color: #333;">欣奕除疤{{ workTimeConfig.shop_name }}</div>
    </div>

    <!-- 新增预约弹窗 -->
    <el-dialog
      :title="isAdd ? '新增' : '编辑'"
      :visible.sync="dialogAppointVisible"
      width="700px"
      :close-on-click-modal="false"
      :before-close="handleDialogClose"
    >
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="预约" name="first" v-if="customerDetail.is_use != undefined && customerDetail.notic == false || isAdd" >
          <el-form
            ref="appointFormRef"
            :model="appointForm"
            :rules="appointFormRules"
            label-width="100px"
          >
            <el-form-item label="顾客姓名" prop="customer_id">
              <el-select v-model="appointForm.customer_name" :disabled="!isAdd" v-if="!isAdd">
              </el-select>
              <el-select v-model="appointForm.customer_id" v-else clearable remote :remote-method="getCustomerList" filterable placeholder="请输入" class="w240" :disabled="!isAdd">
                <el-option v-for="item in customerlist" :key="item.id" :label="item.customer_name" :value="item.id">
                  <span style="float: left">{{ item.customer_name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.telephone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预约日期" prop="appointDate">
              <el-date-picker
                v-model="appointForm.appointDate"
                type="date"
                placeholder="请选择预约日期" 
                class="w240"
                :picker-options="{
                    disabledDate: disabledPastDate
                }"
                :value-format="'yyyy-MM-dd'"
              />
            </el-form-item>

            <el-form-item label="是否到店" prop="in_store" v-if="!isAdd">
              <el-radio-group v-model="appointForm.in_store" size="small">
                <el-radio :label="0">未到店</el-radio>
                <el-radio :label="1">已到店</el-radio>
              </el-radio-group>
            </el-form-item>
            
            <el-form-item label="预约时间段">
              <el-time-select placeholder="起始时间" v-model="appointForm.startTime" :picker-options="{
                    start: '08:00',
                    step: workTimeConfig.isTime == 2 ? '01:00' :'00:30',
                    end: '23:00',
                    minTime: checkIsToday(appointForm.appointDate) ? calcMinTime() : undefined
                  }"
                  class="w180"
              >
              </el-time-select>
              <el-time-select placeholder="结束时间" v-model="appointForm.endTime" :picker-options="{
                  start: '08:00',
                  step: workTimeConfig.isTime == 2 ? '01:00' :'00:30',
                  end: '23:00',
                  minTime: calculateTimeStrByMinutes(this.appointForm.startTime,  (workTimeConfig.isTime == 2 ? -60 : -30))
                }"
                class="w180"
              >
              </el-time-select>
              <div>
                预约成功后，该顾客的预约结束时间是:{{ calculateTimeStrByMinutes(this.appointForm.endTime,  (workTimeConfig.isTime == 2 ? 60 : 30))}}
              </div>
            </el-form-item>
            <el-form-item label="预约护理师" prop="shop_person_id">
              <el-select
                v-model="appointForm.shop_person_id"
                placeholder="请选择护理师"
                class="w240"
              >
                <el-option
                  v-for="item in counselorListWithDefault"
                  :key="item.shop_person_id"
                  :label="item.name"
                  :value="item.shop_person_id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="appointForm.remark"
                type="textarea"
                rows="3"
                placeholder="请输入备注"
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="备注" name="second" v-if="customerDetail.notic == true && customerDetail.is_use == undefined || isAdd">
          <el-form
            ref="remarkFormRef"
            :model="remarkForm"
            :rules="remarkFormRules"
            label-width="100px"
          >
            <el-form-item label="备注内容" prop="remark">
              <el-input
                v-model="remarkForm.remark"
                type="textarea"
                rows="2"
                placeholder="请输入备注内容（最多50字）"
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
            <el-form-item label="备注类型" prop="type">
              <el-radio-group v-model="remarkForm.type">
                <el-radio :label="1">个人通知</el-radio>
                <el-radio :label="2">店铺通知</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注日期" prop="remarkDate">
              <el-date-picker
                v-model="remarkForm.remarkDate"
                type="date"
                placeholder="请选择备注日期"
                class="w240"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item label="备注时间段">
              <el-time-select placeholder="起始时间" v-model="remarkForm.time_start" :picker-options="{
                    start: '08:00',
                    step: workTimeConfig.isTime == 2 ? '01:00' :'00:30',
                    end: '23:00',
                    minTime: checkIsToday(appointForm.appointDate) ? calcMinTime() : undefined
                  }"
              >
              </el-time-select>
              <el-time-select placeholder="结束时间" v-model="remarkForm.time_end" :picker-options="{
                  start: '08:00',
                  step: workTimeConfig.isTime == 2 ? '01:00' :'00:30',
                  end: '23:00',
                  minTime: remarkForm.time_start
                }"
              >
              </el-time-select>
            </el-form-item>
            <el-form-item label="备注护理师" prop="person_id" v-if="remarkForm.type == 1">
              <el-select
                v-model="remarkForm.person_id"
                placeholder="请选择护理师"
                class="w240"
              >
                <el-option
                  v-for="item in counselorListWithDefault"
                  :key="item.shop_person_id"
                  :label="item.name"
                  :value="item.shop_person_id"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <template #footer>
        <el-button @click="handleDialogClose">关闭</el-button>

        <!-- 删除备注：使用 customerDetail，不再报错 -->
        <el-button
          @click="cancelNotice"
          v-if="activeTab !== 'first' && customerDetail && customerDetail.can_delete == 1"
        >
          删除备注
        </el-button>

        <el-button
          @click="cancelBook"
          v-if="activeTab === 'first' && !isAdd"
        >
          取消预约
        </el-button>

        <el-button type="primary" @click="handleSaveAppoint">
          确定保存
        </el-button>
      </template>
    </el-dialog>
    <el-dialog
      title="标语"
      :visible.sync="sloganDialog"
      width="50%"
    >
      <el-input v-model="slogan" type="textarea" rows="3" placeholder="请输入工作时间规划"></el-input>
      <template #footer>
        <el-button @click="sloganDialog = false">关闭</el-button>
        <el-button type="primary" @click="submitSlogan">确定保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import FullCalendar, { isValidDate } from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'
import zhCnLocale from '@fullcalendar/core/locales/zh-cn'
import { mapGetters } from 'vuex'
import { personcustomerList,newbooksList3,submitBooks,cancelBook,cancelNotice,updateYYData,addNotice,editNotice,updateAdminShopResource } from "@/api/client";
import { getShopList } from "@/api/shop";
import { MessageBox, Message } from 'element-ui';

// 日期工具函数
const DateUtils = {
  formatYmd: (date, separator = '-') => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}${separator}${month}${separator}${day}`;
  },
  formatHm: (date) => `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`,
  combineDateTime: (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return ''
    return `${dateStr}T${timeStr.includes(':') ? timeStr : `${timeStr}:00`}`
  },
  formatDateTime:(dateStr, timeStr) => {
    if (!dateStr || !timeStr) return '';
    return `${dateStr} ${timeStr}:00`;
  },
  isPastDate: (date, includeToday = false) => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const target = new Date(date)
    target.setHours(0, 0, 0, 0)
    return includeToday ? target < today : target <= today
  },
  isPastTime: (date) => {
    const now = new Date()
    now.setSeconds(0, 0)
    const target = new Date(date)
    target.setSeconds(0, 0)
    return target < now
  },
  isTodayExpiredSlot: (slotDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const slotDay = new Date(slotDate);
    slotDay.setHours(0, 0, 0, 0);
    return slotDay.getTime() === today.getTime() && DateUtils.isPastTime(slotDate);
  },
  formatViewEndDate: (date) => {
    const endDate = new Date(date);
    endDate.setDate(endDate.getDate() - 1);
    return DateUtils.formatYmd(endDate);
  }
}

// 常量配置 - 状态对应背景色
const APPOINT_CONFIG = {
  COLOR_MAP: {
    0: '#fff2e1',
    1: '#f3ffed',
  }
}

// 状态-类名映射
const STATUS_CLASS_MAP = {
  0: 'event-status-3',
  1: 'event-status-7',
};

// 默认咨询师配置
const DEFAULT_COUNSELOR = {
  shop_person_id: 'default_counselor',
  name: '备注',
  identityId: 0,
  identityName: '备注',
  userStatus: 1,
  appointCount: 0,
  maxCount: 20,
  phone: ''
}

const Remark_FormRules = {
  remark: [{ required: true, message: '请输入备注内容', trigger: 'blur' }],
  person_id: [{ required: true, message: '请选择护理师', trigger: 'change' }],
  remarkDate: [{ required: true, message: '请选择备注日期', trigger: 'change' }],
  type: [{ required: true, message: '请选择备注类型', trigger: 'change' }],
}

const Appoint_FormRules = {
  appointDate: [{ required: true, message: '请选择预约日期', trigger: 'change' }],
  customer_id: [{ required: true, message: '请输入患者姓名', trigger: 'blur' }],
  shop_person_id: [{ required: true, message: '请选择护理师', trigger: 'change' }],
}

export default {
  name: 'AppointmentCalendar',
  components: { FullCalendar },
  data() {
    return {
      statusTags: [
        { text: '备注', color: '#ff7676' },
        { text: '已核销', color: '#90cb73' },
        { text: '已到店', color: '#fcff8d' },
        { text: '未到店', color: '#ffad48' },
        { text: '预测', color: '#F0F7FF' }
      ],
      slogan: '',
      sloganDialog: false,
      shop_id: "",
      shopOptionsList: [
          {shopId:'73782774834649',shopName:'大学路'}
      ],
      customerDetail: {},
      clickCount: 0, 
      clickTimer: null, 
      isAdd: true,
      activeTab: 'first',
      customerlist: [],
      todoEvents: [],
      isLoading: false,
      counselorList: [],
      selectedDate: DateUtils.formatYmd(new Date()),
      workTimeConfig: {
        startTime: '08:00:00',
        endTime: '21:00:00',
        isTime: 1,
        shop_name: '',
        slogan: ''
      },
      dialogAppointVisible: false,
      searchForm: {
        start_time:'',
        end_time:''
      },
      appointForm: {
        appointDate: this.selectedDate,
        in_store: '',
        startTime: '',
        endTime: '',
        customer_id: '',
        customer_name: '',
        patientPhone: '',
        shop_person_id: '',
        remark: ''
      },
      remarkForm: {
        remark: '',
        time_end: '',
        time_start: '',
        shop_id: '',
        person_id: '',
        create_id: '',  
        remarkDate: this.selectedDate,
        type: '',
      },
      appointFormRules: Appoint_FormRules,
      remarkFormRules: Remark_FormRules,
      remarkList: [],
      calendarOptions: null,
      eventTouchTimer: null,
      isDragging: false,
      dragOriginalEvent: null,
      lastFetchTimeRange: { start: '', end: '' },
      lastFetchViewType: '',
      // 存储原始完整事件数据（包含预测）
      allEvents: [],
      // 当前视图类型
      currentViewType: 'resourceTimeGridDay'
    }
  },
  watch: {
    workTimeConfig: {
      deep: true,
      handler() {
        this.updateCalendarTimeSlotConfig();
      },
    },
  },
  
  computed: {
    ...mapGetters(["userInfo"]),
    counselorListWithDefault() {
      if (!Array.isArray(this.counselorList) || this.counselorList.length === 0) {
        return [DEFAULT_COUNSELOR]
      }
      const allCounselors = [...this.counselorList]
      return Array.from(new Map(allCounselors.map(item => [item.shop_person_id, item]))).map(item => item[1])
    },
    hasValidCounselor() {
      return this.counselorListWithDefault.length > 0
    }
  },
  created() {
    this.initCalendar();
    this.shop_id = this.userInfo.shop_id || '73782774834649';
    this.getShopList();
  },
  mounted() {
    this.$nextTick(() => {
      this.updateCalendarTimeSlotConfig();
    });
  },
  methods: {
    checkIsToday(selectDate) {
      if (!selectDate) return false;
      const today = new Date().toISOString().split('T')[0];
      return selectDate === today;
    },
    calcMinTime() {
      const now = new Date();
      let hour = now.getHours();
      const minute = now.getMinutes();
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    },
    updateCalendarTimeSlotConfig() {
      if (this.$refs.fullCalendar) {
        const calendarApi = this.$refs.fullCalendar.getApi();
        if (calendarApi) {
          const interval = this.workTimeConfig.isTime === 1 ? '00:30:00' : '01:00:00';
          calendarApi.setOption('slotDuration', interval);
          calendarApi.setOption('slotLabelInterval', interval);
          calendarApi.setOption('snapDuration', interval);
        }
      }
    },
    calculateTimeStrByMinutes(timeStr, offsetMinutes) {
      if (!timeStr) return '';
      const [hours, minutes] = timeStr.split(':').map(Number);
      const date = new Date();
      date.setHours(hours, minutes + offsetMinutes, 0);
      const newHours = String(date.getHours()).padStart(2, '0');
      const newMinutes = String(date.getMinutes()).padStart(2, '0');
      return `${newHours}:${newMinutes}`;
    },
    submitSlogan() {
      updateAdminShopResource({
        shopId: this.shop_id,
        slogan: this.slogan
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          });
          this.isAdd = true
          this.sloganDialog = false;
          this.fetchAppointData();
          this.$nextTick(() => {
            this.handleExpiredSlotStyle();
          });
        } else {
          this.$message({
            message: res.msg || '更新失败',
            type: 'error'
          });
        }
      });
    },
    openSlogan() {
      this.sloganDialog = true;
      this.slogan = this.workTimeConfig.slogan 
    },
    getShopList() {
      getShopList({ page: 1, limit: 100000,status:1}).then(res => {
        this.shopOptionsList = res.list;
      });
    },
    getCustomerList(query) {
      personcustomerList({
        person_id: this.userInfo.shop_person_id || this.counselorList[0]?.shop_person_id,
        keyword: query || ''
      }).then(res => {
        this.customerlist = res.data;
      });
    },
    initCalendar() {
      const that = this;
      this.calendarOptions = {
        locale: zhCnLocale,
        resourceOrder: 'order',
        resources: [], 
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          resourceTimeGridPlugin
        ],
        initialView: 'resourceTimeGridDay',
        headerToolbar: {
          left: 'prev,next,today,tomorrow,dayAfterTomorrow',
          center: 'title',
          right: 'resourceTimeGridDay,timeGridWeek,dayGridMonth'
        },
        customButtons: {
          tomorrow: {
            text: '明天', 
            click: function() {
              const calendarApi = that.$refs.fullCalendar.getApi();
              const today = new Date();
              const tomorrow = new Date(today);
              tomorrow.setDate(today.getDate() + 1);
              calendarApi.gotoDate(tomorrow); 
              that.selectedDate = DateUtils.formatYmd(tomorrow);
              that.searchForm.start_time = that.selectedDate;
              that.searchForm.end_time = that.selectedDate;
            }
          },
          dayAfterTomorrow: {
            text: '后天', 
            click: function() {
              const calendarApi = that.$refs.fullCalendar.getApi();
              const today = new Date();
              const dayAfterTomorrow = new Date(today);
              dayAfterTomorrow.setDate(today.getDate() + 2); 
              calendarApi.gotoDate(dayAfterTomorrow); 
              that.selectedDate = DateUtils.formatYmd(dayAfterTomorrow);
              that.searchForm.start_time = that.selectedDate;
              that.searchForm.end_time = that.selectedDate;
            }
          }
        },
        slotDuration: this.workTimeConfig.isTime == 1 ? '00:30:00' : '01:00:00',
        slotMinTime: '08:00:00',
        slotMaxTime: '23:00:00',
        slotLabelInterval: this.workTimeConfig.isTime == 1 ? '00:30:00' : '01:00:00',
        snapDuration: this.workTimeConfig.isTime == 1 ? '00:30:00' : '01:00:00',
        allDaySlot: false,
        slotLabelFormat: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        },
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        },
        height: 'auto',
        contentHeight: 'auto',
        expandRows: true,
        resourceAreaWidth: '180px',
        nowIndicator: true,
        resources: [],
        events: [],
        editable: true,
        selectable: true, 
        selectMirror: true,
        dayMaxEvents: true,
        eventDisplay: 'block',
        views: {
          dayGridMonth: {
            eventDisplay: 'block',
          }
        },
        selectAllow: this.handleSelectAllow.bind(this),
        select: this.handleCalendarSelect.bind(this),
        unselect: () => {},
        eventAllow: this.handleEventAllow.bind(this),
        eventDidMount: this.handleEventDidMount.bind(this),
        eventClick: this.handleEventClick.bind(this),
        datesSet: async (info) => {
          this.selectedDate = DateUtils.formatYmd(info.view.currentStart);
          const currentStart = DateUtils.formatYmd(info.view.currentStart);
          const currentEnd = DateUtils.formatViewEndDate(info.view.currentEnd);
          this.searchForm.start_time = currentStart;
          this.searchForm.end_time = currentEnd;
          this.currentViewType = info.view.type;
          await this.fetchAppointData();
          this.$nextTick(() => {
            this.handleExpiredSlotStyle();
          });
        },
        eventDragStart: function(info) {
          // 判断是否为预测数据，如果是则不允许拖拽
          const extendInfo = info?.event?._def?.extendedProps?.extendInfo;
          if (extendInfo?.is_predict) {
            return;
          }
          that.isDragging = true;
          that.dragOriginalEvent = {
            id: info.event.id,
            start: info.event.start,
            end: info.event.end,
            resourceId: info.event.resourceId
          };
          const popover = document.querySelector(`#popover-${info.event.id}`);
          if (popover) {
            popover.style.opacity = '0';
            popover.style.display = 'none';
          }
        },
        eventDrop: function(info) {
          // 判断是否为预测数据，如果是则回退
          const extendInfo = info?.event?._def?.extendedProps?.extendInfo;
          if (extendInfo?.is_predict) {
            info.revert();
            Message.warning('预测数据不支持拖拽修改');
            that.isDragging = false;
            that.dragOriginalEvent = null;
            return;
          }
          if (!info?.event || !that?.dragOriginalEvent || !Array.isArray(that.todoEvents)) {
            Message.warning('操作失败：预约信息异常');
            that.isDragging = false;
            that.dragOriginalEvent = null;
            return;
          }
          try {
            const newStartTime = DateUtils.formatHm(info.event.start);
            const newEndTime = DateUtils.formatHm(info.event.end);
            const newDate = DateUtils.formatYmd(info.event.start);
            const newCounselor = info.newResource?._resource?.title || extendInfo.appoint_persons[0]?.name || DEFAULT_COUNSELOR.name;
            const newPersonId = info.newResource?._resource?.id || extendInfo.appoint_persons[0]?.shop_person_id || DEFAULT_COUNSELOR.shop_person_id;

            if (extendInfo.is_use !== undefined) {
              MessageBox.confirm(
                `预约时间调整为${newDate} ${newStartTime}-${newEndTime}，预约人调整为【${newCounselor}】，是否确认调整？`,
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                  closeOnClickModal: false
                }
              ).then(async () => {
                try {
                  const yy_time = that.generateTimePoints(newStartTime, newEndTime, that.workTimeConfig.isTime == 1 ? 30 : 60); 
                  const params = {
                    customer_id: extendInfo.customer_id,
                    shop_person_id: newPersonId,
                    yy_year: newDate.split('-')[0],
                    yy_date: newDate.split('-')[1] + '-' + newDate.split('-')[2],
                    yy_time: yy_time.slice(0, yy_time.length - 1),
                    shop_id: that.shop_id,
                    remark: extendInfo.remark,
                    type: 2
                  }
                  let res = await updateYYData({...params, book_id: extendInfo.id, operator: that.userInfo.id})
                  if (res.data.success) {
                    Message.success(res.data.message)
                    that.isDragging = false;
                    that.dragOriginalEvent = null;
                    await that.fetchAppointData();
                    that.$nextTick(() => {
                      that.handleExpiredSlotStyle();
                    });
                  } else {
                    info.revert();
                    that.isDragging = false;
                    that.dragOriginalEvent = null;
                    Message.error(res.data.error || '预约失败')
                  }
                } catch (updateError) {
                  info.revert();
                  that.isDragging = false;
                  that.dragOriginalEvent = null;
                }
              }).catch(() => {
                info.revert();
                that.isDragging = false;
                that.dragOriginalEvent = null;
                Message.info('已取消预约修改');
              })
            } else {
              MessageBox.confirm(
                `备注时间调整为${newDate} ${newStartTime}-${newEndTime}，备注人调整为【${newCounselor}】，是否确认调整？`,
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                  closeOnClickModal: false
                }
              ).then(async () => {
                try {
                  const remarkStartTime = DateUtils.formatDateTime(newDate, newStartTime);
                  const remarkEndTime = DateUtils.formatDateTime(newDate, newEndTime);
                  const type = newPersonId == 'default_counselor' ? 2 : 1;
                  const params1 = {
                    time_start: remarkStartTime,
                    time_end: remarkEndTime,
                    person_id: type == 2 ? '' : newPersonId,
                    remark: extendInfo.remark,
                    type: type,
                    create_id: that.userInfo.id,
                    shop_id: that.shop_id,
                  }
                  let res = await editNotice({...params1, id: extendInfo.id})
                  if (res.code == 200) {
                    Message.success(res.msg)
                    that.isDragging = false;
                    that.dragOriginalEvent = null;
                    await that.fetchAppointData();
                    that.$nextTick(() => {
                      that.handleExpiredSlotStyle();
                    });
                  } else {
                    info.revert();
                    that.isDragging = false;
                    that.dragOriginalEvent = null;
                    Message.error(res.data.error || '修改失败')
                  }
                } catch (updateError) {
                  info.revert();
                  that.isDragging = false;
                  that.dragOriginalEvent = null;
                }
              }).catch(() => {
                info.revert();
                that.isDragging = false;
                that.dragOriginalEvent = null;
                Message.info('已取消备注修改');
              })
            }
          } catch (formatError) {
            console.log(formatError, '修改失败')
            info.revert();
            that.isDragging = false;
            that.dragOriginalEvent = null;
          }
        },
        eventDragStop: function() {
          if (!that.dragOriginalEvent) {
            that.isDragging = false;
            that.dragOriginalEvent = null;
          }
        },
        eventResizeStart: function(info) {
          // 判断是否为预测数据，如果是则不允许调整
          const extendInfo = info?.event?._def?.extendedProps?.extendInfo;
          if (extendInfo?.is_predict) {
            return;
          }
          that.isDragging = true;
          that.dragOriginalEvent = {
            id: info.event.id,
            start: info.event.start,
            end: info.event.end
          };
          const popover = document.querySelector(`#popover-${info.event.id}`);
          if (popover) {
            popover.style.opacity = '0';
            popover.style.display = 'none';
          }
        },
        eventResize: function(info) {
          // 判断是否为预测数据，如果是则回退
          const extendInfo = info?.event?._def?.extendedProps?.extendInfo;
          if (extendInfo?.is_predict) {
            info.revert();
            Message.warning('预测数据不支持调整大小');
            that.isDragging = false;
            that.dragOriginalEvent = null;
            return;
          }
          if (!info?.event || !that?.dragOriginalEvent || !Array.isArray(that.todoEvents)) {
            Message.warning('操作失败：预约信息异常');
            that.isDragging = false;
            that.dragOriginalEvent = null;
            return;
          }
          try {
            const newStartTime = DateUtils.formatHm(info.event.start);
            const newEndTime = DateUtils.formatHm(info.event.end);
            const newDate = DateUtils.formatYmd(info.event.start);
            const newCounselor = info.newResource?._resource?.title || extendInfo.appoint_persons[0]?.name || DEFAULT_COUNSELOR.name;
            const newPersonId = info.newResource?._resource?.id || extendInfo.appoint_persons[0]?.shop_person_id || DEFAULT_COUNSELOR.shop_person_id;

            if (extendInfo.is_use !== undefined) {
              MessageBox.confirm(
                `预约时间调整为${newDate} ${newStartTime}-${newEndTime}，预约人调整为【${newCounselor}】，是否确认调整？`,
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                  closeOnClickModal: false
                }
              ).then(async () => {
                try {
                  const yy_time = that.generateTimePoints(newStartTime, newEndTime, that.workTimeConfig.isTime == 1 ? 30 : 60); 
                  const params = {
                    customer_id: extendInfo.customer_id,
                    shop_person_id: newPersonId,
                    yy_year: newDate.split('-')[0],
                    yy_date: newDate.split('-')[1] + '-' + newDate.split('-')[2],
                    yy_time: yy_time.slice(0, yy_time.length - 1),
                    shop_id: that.shop_id,
                    remark: extendInfo.remark,
                  }
                  let res = await updateYYData({...params, book_id: extendInfo.id, operator: that.userInfo.id})
                  if (res.data.success) {
                    Message.success(res.data.message)
                    that.isDragging = false;
                    that.dragOriginalEvent = null;
                    await that.fetchAppointData();
                    that.$nextTick(() => {
                      that.handleExpiredSlotStyle();
                    });
                  } else {
                    info.revert();
                    that.isDragging = false;
                    that.dragOriginalEvent = null;
                    Message.error(res.data.error || '预约失败')
                  }
                } catch (updateError) {
                  info.revert();
                  that.isDragging = false;
                  that.dragOriginalEvent = null;
                }
              }).catch(() => {
                info.revert();
                that.isDragging = false;
                that.dragOriginalEvent = null;
                Message.info('已取消预约修改');
              })
            } else {
              MessageBox.confirm(
                `备注时间调整为${newDate} ${newStartTime}-${newEndTime}，备注人调整为【${newCounselor}】，是否确认调整？`,
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                  closeOnClickModal: false
                }
              ).then(async () => {
                try {
                  const remarkStartTime = DateUtils.formatDateTime(newDate, newStartTime);
                  const remarkEndTime = DateUtils.formatDateTime(newDate, newEndTime);
                  const type = newPersonId == 'default_counselor' ? 2 : 1;
                  const params1 = {
                    time_start: remarkStartTime,
                    time_end: remarkEndTime,
                    person_id: type == 2 ? '' : newPersonId,
                    remark: extendInfo.remark,
                    type: type,
                    create_id: that.userInfo.id,
                    shop_id: that.shop_id,
                  }
                  let res = await editNotice({...params1, id: extendInfo.id})
                  if (res.code == 200) {
                    Message.success(res.msg)
                    that.isDragging = false;
                    that.dragOriginalEvent = null;
                    await that.fetchAppointData();
                    that.$nextTick(() => {
                      that.handleExpiredSlotStyle();
                    });
                  } else {
                    info.revert();
                    that.isDragging = false;
                    that.dragOriginalEvent = null;
                    Message.error(res.data.error || '修改失败')
                  }
                } catch (updateError) {
                  info.revert();
                  that.isDragging = false;
                  that.dragOriginalEvent = null;
                }
              }).catch(() => {
                info.revert();
                that.isDragging = false;
                that.dragOriginalEvent = null;
                Message.info('已取消备注修改');
              })
            }
          } catch (formatError) {
            console.log(formatError, '修改失败')
            info.revert();
            that.isDragging = false;
            that.dragOriginalEvent = null;
          }
        },
        eventResizeStop: function() {
          if (!that.dragOriginalEvent) {
            that.isDragging = false;
            that.dragOriginalEvent = null;
          }
        }
      }
    },

    handleExpiredSlotStyle() {
      const calendarApi = this.$refs.fullCalendar?.getApi();
      if (!calendarApi) return;

      const today = this.selectedDate || DateUtils.formatYmd(new Date());
      const slotElements = document.querySelectorAll('.fc-timegrid-slot-lane[data-time]');

      document.querySelectorAll('.slot-add-remark, .slot-remark-content').forEach(el => el.remove());
      
      slotElements.forEach(el => {
        el.classList.remove('fc-slot-today-expired');
        el.style.pointerEvents = 'auto';
      });

      slotElements.forEach(el => {
        const slotTimeStr = el.getAttribute('data-time');
        if (!slotTimeStr || !today) return;

        const slotDateTimeStr = `${today} ${slotTimeStr}`;
        const slotDate = new Date(slotDateTimeStr);
        const isExpired = DateUtils.isTodayExpiredSlot(slotDate) || DateUtils.isPastTime(slotDate);

        if (isExpired) {
          el.classList.add('fc-slot-today-expired');
          el.style.pointerEvents = 'none';
        }
      });

      this.renderSavedRemarks();
    },

    renderSavedRemarks() {
      const calendarApi = this.$refs.fullCalendar?.getApi();
      if (!calendarApi || this.remarkList.length === 0) return;

      const today = this.selectedDate || DateUtils.formatYmd(new Date());
      const resourceElements = document.querySelectorAll('.fc-resource-cell');
      
      resourceElements.forEach(resEl => {
        const shop_person_id = resEl.getAttribute('data-resource-id');
        if (!shop_person_id) return;

        const slotElements = resEl.parentElement.querySelectorAll('.fc-timegrid-slot-lane[data-time]');
        slotElements.forEach(slotEl => {
          const slotTimeStr = slotEl.getAttribute('data-time');
          if (!slotTimeStr) return;

          const remark = this.remarkList.find(item => 
            item.date === today && item.timeSlot === slotTimeStr && item.shop_person_id === shop_person_id
          );
          
          if (remark) {
            const remarkEl = document.createElement('div');
            remarkEl.className = 'slot-remark-content';
            remarkEl.innerText = remark.content;
            remarkEl.style.cssText = `
              position: absolute;
              top: 2px;
              left: 2px;
              font-size: 12px;
              color: #666;
              max-width: calc(100% - 10px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              z-index: 5;
            `;
            slotEl.appendChild(remarkEl);
          }
        });
      });
    },

    validateEndTime(rule, value, callback) {
      if (!value) {
        callback(new Error('请选择结束时间'))
      } else {
        const { startTime, appointDate } = this.appointForm
        if (startTime && appointDate) {
          const start = new Date(`${appointDate} ${startTime}`)
          const end = new Date(`${appointDate} ${value}`)
          if (end <= start) {
            callback(new Error('结束时间必须晚于开始时间'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    },

    // 格式化预约事件数据 - 支持 appointments
    formatAppointEvents(appointVos, isPredict = false) {
      if (!Array.isArray(appointVos)) return []
      
      return appointVos.map(item => {
        const start = DateUtils.combineDateTime(item.appoint_date_str, item.appoint_time_start_str)
        const end = DateUtils.combineDateTime(item.appoint_date_str, item.appoint_time_end_str)
        const shop_person_id = item.appoint_persons?.[0]?.shop_person_id || DEFAULT_COUNSELOR.shop_person_id
        
        let bgColor, statusClass;
        if (isPredict) {
          bgColor = '#FBFDFF';
          statusClass = 'event-status-predict';
        } else {
          bgColor = APPOINT_CONFIG.COLOR_MAP[item.is_use] || '#faeaea';
          statusClass = STATUS_CLASS_MAP[item.is_use] || 'event-status-5';
        }
        
        const bgColor1 = '#fffbcc';
        const statusClass1 = 'event-status-6';
        
        const predictPrefix = isPredict ? '【预】' : '';
        const defaultTitle = item.notic == true 
          ? `备注：${item.remark}` 
          : isPredict
            ? `${predictPrefix} ${item.customer_name || '无'} ${item.telephone || ''}`
            : `${predictPrefix} ${item.customer_name || '无'} ${item.telephone || ''}(${item.type_text})\n备注：${item.remark || '无'}`;
        const monthTitle = item.notic == true 
          ? `备注：${item.remark}` 
          : `${predictPrefix}${item.type_text} ${item.customer_name}(${item.telephone || ''})`;

        return {
          id: `${isPredict ? 'predict_' : 'appoint_'}${item.id}`,
          title: defaultTitle,
          start,
          end,
          backgroundColor: item.in_store == '已到店' && item.is_use == 0 ? bgColor1 : bgColor,
          borderColor: 'transparent',
          textColor: isPredict ? '#66a3ee' : '#333',
          extendedProps: { 
            extendInfo: { ...item, is_predict: isPredict },
            monthTitle: monthTitle,
            isPredict: isPredict
          },
          resourceId: shop_person_id,
          className: [
            item.in_store == '已到店' && item.is_use == 0 ? statusClass1 : statusClass,
            isPredict ? 'event-predict' : ''
          ].filter(Boolean)
        }
      })
    },

    // 把预测数据按 护理师+日期+起止时间 分组
    aggregatePredictGroups(predictList) {
      if (!Array.isArray(predictList) || predictList.length === 0) return []
      const groupMap = new Map()
      predictList.forEach(item => {
        const shop_person_id = item.appoint_persons?.[0]?.shop_person_id || DEFAULT_COUNSELOR.shop_person_id
        const key = [
          shop_person_id,
          item.appoint_date_str,
          item.appoint_time_start_str,
          item.appoint_time_end_str
        ].join('|')
        if (!groupMap.has(key)) {
          groupMap.set(key, {
            shop_person_id,
            appoint_date_str: item.appoint_date_str,
            appoint_time_start_str: item.appoint_time_start_str,
            appoint_time_end_str: item.appoint_time_end_str,
            appoint_persons: item.appoint_persons,
            predictList: []
          })
        }
        groupMap.get(key).predictList.push(item)
      })
      return Array.from(groupMap.values())
    },

    // 把分组格式化成日历事件
    formatAggregatedPredictEvents(groups) {
      if (!Array.isArray(groups)) return []
      return groups.map((group, idx) => {
        const start = DateUtils.combineDateTime(group.appoint_date_str, group.appoint_time_start_str)
        const end = DateUtils.combineDateTime(group.appoint_date_str, group.appoint_time_end_str)
        const count = group.predictList.length
        const names = group.predictList
          .map(p => p.customer_name)
          .filter(Boolean)
          .slice(0, 3)
          .join('/')
        const moreText = count > 3 ? ` 等${count}人` : (count > 1 ? ` ${count}人` : '')
        const title = `【预】${names || '未知'}${moreText}`
        return {
          id: `predict_group_${group.shop_person_id}_${group.appoint_date_str}_${group.appoint_time_start_str}_${idx}`,
          title,
          start,
          end,
          backgroundColor: '#FBFDFF',
          borderColor: '#b8d9f0',
          borderWidth: '1px',
          textColor: '#66a3ee',
          extendedProps: {
            extendInfo: {
              ...group.predictList[0],
              is_predict: true,
              is_aggregated: count > 1,
              predictList: group.predictList
            },
            isPredict: true
          },
          resourceId: group.shop_person_id,
          className: ['event-status-predict', 'event-predict', 'event-predict-compact'].filter(Boolean)
        }
      })
    },

    formatCounselorResources(counselorList) {
      const uniqueCounselors = [];
      const seenIds = new Set();
      let orderIndex = 0;
      
      if (Array.isArray(counselorList)) {
        counselorList.forEach(item => {
          if (!seenIds.has(item.shop_person_id)) {
            seenIds.add(item.shop_person_id);
            uniqueCounselors.push({
              id: item.shop_person_id,
              title: item.name,
              name: item.name,
              shop_person_id: item.shop_person_id,
              order: orderIndex++ 
            });
          }
        });
      }
      
      if (!seenIds.has(DEFAULT_COUNSELOR.shop_person_id)) {
        uniqueCounselors.push({
          id: DEFAULT_COUNSELOR.shop_person_id,
          title: DEFAULT_COUNSELOR.name,
          name: DEFAULT_COUNSELOR.name,
          shop_person_id: DEFAULT_COUNSELOR.shop_person_id,
          order: orderIndex++
        });
      }
      
      return uniqueCounselors;
    },

    // 判断当前视图是否为周月视图
    isWeekMonthView(viewType) {
      return viewType === 'timeGridWeek' || viewType === 'dayGridMonth';
    },

    // 根据视图类型过滤事件
    filterEventsByView(events, viewType) {
      if (!Array.isArray(events)) return [];
      // 如果是周月视图，过滤掉预测数据
      if (this.isWeekMonthView(viewType)) {
        return events.filter(event => {
          const isPredict = event.extendedProps?.isPredict || event.extendedProps?.extendInfo?.is_predict;
          return !isPredict;
        });
      }
      return events;
    },

    async fetchAppointData() {
      try {
        this.isLoading = true;

        const res = await newbooksList3({
          shop_id: this.shop_id,
          ...this.searchForm
        })
        
        if (res) {
          this.workTimeConfig = {
            startTime: res.time_setting.start_time,
            endTime: res.time_setting.end_time,
            isTime: res.time_setting.show_type,
            shop_name: res.time_setting.shop_name,
            slogan: res.time_setting.slogan || ''
          }
          
          this.counselorList = res.staff_list || []

          // 合并 appointments 和 predict 数据
          const appointments = res.appointments || [];
          const predictData = res.predict || [];
          
          // 分别格式化两种数据
          const formattedAppointments = this.formatAppointEvents(appointments, false);
          
          // 预测数据聚合：同一护理师同一时间段合并为一个块，避免看板拥挤
          const aggregatedPredictGroups = this.aggregatePredictGroups(predictData);
          const formattedPredict = this.formatAggregatedPredictEvents(aggregatedPredictGroups);
          
          // 合并所有事件 - 存储到 allEvents
          const notices = res.notice || [];
          const formattedNotices = this.formatAppointEvents(notices, false);
          this.allEvents = [...formattedAppointments, ...formattedPredict, ...formattedNotices];
          
          // 根据当前视图过滤事件
          const filteredEvents = this.filterEventsByView(this.allEvents, this.currentViewType);
          this.todoEvents = filteredEvents;

          // 设置默认咨询师
          if (this.counselorListWithDefault.length > 0) {
            this.appointForm.shop_person_id = this.counselorListWithDefault[0].shop_person_id
          }
          
          this.$nextTick(() => {
            const calendarInstance = this.$refs.fullCalendar?.getApi();
            if (calendarInstance) {
              calendarInstance.getResources().forEach(res => res.remove());
              const newResources = this.formatCounselorResources(this.counselorList);
              newResources.forEach(res => calendarInstance.addResource(res));
              calendarInstance.removeAllEvents();
              calendarInstance.addEventSource(this.todoEvents);
              this.handleExpiredSlotStyle();
            }
          })
        }
      } catch (error) {
        this.$message.error('数据加载失败，请刷新重试')
      } finally {
        this.isLoading = false;
      }
    },

    // 视图切换时重新过滤事件
    updateEventsByView(viewType) {
      this.currentViewType = viewType;
      const filteredEvents = this.filterEventsByView(this.allEvents, viewType);
      this.todoEvents = filteredEvents;
      
      const calendarInstance = this.$refs.fullCalendar?.getApi();
      if (calendarInstance) {
        calendarInstance.removeAllEvents();
        calendarInstance.addEventSource(this.todoEvents);
      }
    },

    openAppointDialog() {
      this.customerDetail = {}
      this.isAdd = true
      if (!this.hasValidCounselor) {
        this.$message.warning('暂无可用咨询师')
        return
      }
      this.appointForm = {
        appointDate: this.selectedDate,
        startTime: '',
        endTime: '',
        customer_name: '',
        in_store: '',
        customer_id: '',
        shop_person_id: '',
        remark: '',
      }
      this.remarkForm = {
        remark: '',
        time_end: '',
        time_start: '',
        shop_id: '',
        person_id: '',
        create_id: '',  
        type: '',
        remarkDate: this.selectedDate,
      }
      
      this.dialogAppointVisible = true  
      this.$nextTick(() => {
        this.$refs.appointFormRef?.clearValidate()
        this.$refs.remarkFormRef?.clearValidate()
      })
    },

    async handleSaveAppoint() {
      try {
        if (this.activeTab === 'first') {
          if (!this.appointForm.startTime || !this.appointForm.endTime) {
            this.$message.warning('请选择开始/结束时间段')
            return
          }
          await this.$refs.appointFormRef.validate()
        } else {
          if (!this.remarkForm.time_start || !this.remarkForm.time_end) {
            this.$message.warning('请选择开始/结束时间段')
            return
          }
          await this.$refs.remarkFormRef.validate()
        }

        if (this.activeTab === 'first') {
          const yy_time = this.generateTimePoints(this.appointForm.startTime, this.appointForm.endTime, this.workTimeConfig.isTime == 1 ? 30 : 60);
          const params = {
            customer_id: this.appointForm.customer_id,
            customer_name: this.appointForm.customer_name,
            shop_person_id: this.appointForm.shop_person_id,
            yy_year: this.appointForm.appointDate.split('-')[0],
            yy_date: this.appointForm.appointDate.split('-')[1] + '-' + this.appointForm.appointDate.split('-')[2],
            yy_time: yy_time,
            in_store: this.appointForm.in_store,
            shop_id: this.shop_id,
            remark: this.appointForm.remark,
            type: 2
          }
          let res = null
          if (this.isAdd) {
            res = await submitBooks(params)
          } else {
            res = await updateYYData({...params, book_id: this.customerDetail.id, operator: this.userInfo.id})
          }
          if (res.data.error == '预约成功' || res.data.success) {
            this.$message.success(this.isAdd ? '预约成功' : '修改预约成功')
            this.appointForm = {
              appointDate: '',
              startTime: '',
              endTime: '',
              customer_id: '',
              customer_name: '',
              in_store: '',
              patientPhone: '',
              shop_person_id: '',
              remark: ''
            }
            this.isAdd = true
            this.dialogAppointVisible = false
            await this.fetchAppointData();
            this.$nextTick(() => {
              this.handleExpiredSlotStyle();
            });
          } else {
            this.$message.error(res.data.error || '预约失败')
          }
        } else {
          const remarkStartTime = DateUtils.formatDateTime(this.remarkForm.remarkDate, this.remarkForm.time_start);
          const remarkEndTime = DateUtils.formatDateTime(this.remarkForm.remarkDate, this.remarkForm.time_end);
          const params = {
            time_start: remarkStartTime,
            time_end: remarkEndTime,
            person_id: this.remarkForm.type == 1 ? this.remarkForm.person_id : '',
            remark: this.remarkForm.remark,
            type: this.remarkForm.type,
            create_id: this.userInfo.id,
            shop_id: this.shop_id,
          }
          let res = null
          if (this.isAdd) {
            res = await addNotice(params)
          } else {
            res = await editNotice({...params, id: this.customerDetail.id})
          }
          if (res.code == 200) {
            this.$message.success(this.isAdd ? '添加备注成功' : '修改备注成功')
            this.remarkForm = {
              time_start: '',
              time_end: '',
              person_id: '',
              remark: '',
              type: '',
              create_id: '',
              shop_id: '',
            }
            this.isAdd = true
            this.dialogAppointVisible = false
            await this.fetchAppointData();
            this.$nextTick(() => {
              this.handleExpiredSlotStyle();
            });
          } else {
            this.$message.error(res.data.error || '添加备注失败')
          }
        }
      } catch (error) {
        console.error('保存失败：', error)
      }
    },

    generateTimePoints(startTime, endTime, intervalMinutes) {
      const [startHours, startMinutes] = startTime.split(':').map(Number);
      const [endHours, endMinutes] = endTime.split(':').map(Number);

      const startTotalMinutes = startHours * 60 + startMinutes;
      const endTotalMinutes = endHours * 60 + endMinutes;
      const timePoints = [];

      const firstValidMinutes = Math.ceil(startTotalMinutes / intervalMinutes) * intervalMinutes;

      for (let minutes = firstValidMinutes; minutes <= endTotalMinutes; minutes += intervalMinutes) {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        timePoints.push(`${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`);
      }

      return timePoints;
    },

    handleSelectAllow(selectInfo) {
      const now = new Date()
      now.setSeconds(0, 0)
      const selectStart = new Date(selectInfo.start)
      selectStart.setSeconds(0, 0)
      return selectStart >= now
    },

    handleEventAllow(dropInfo) {
      // 判断是否为预测数据
      const event = dropInfo.event;
      const extendInfo = event?._def?.extendedProps?.extendInfo;
      if (extendInfo?.is_predict) {
        return false; // 预测数据不允许拖拉拽
      }
      const isNotPast = !DateUtils.isPastTime(dropInfo.start);
      const isNotTodayExpired = !DateUtils.isTodayExpiredSlot(dropInfo.start);
      return isNotPast && isNotTodayExpired;
    },

    handleEventClick(info) {
      clearTimeout(this.clickTimer);
      this.clickCount++;

      this.clickTimer = setTimeout(() => {
        if (this.clickCount === 1) {
          const extendId = info?.event?._def?.extendedProps?.extendInfo?.id;
          const extendInfo = info?.event?._def?.extendedProps?.extendInfo;

          // 预测数据不支持编辑
          if (extendInfo?.is_predict) {
            this.$message.info('预测数据仅供参考，不支持编辑')
            this.clickCount = 0;
            return;
          }

          this.customerDetail = JSON.parse(JSON.stringify(extendInfo || {}));
          this.activeTab = extendInfo.is_use == undefined ? 'second' : 'first';
          if (extendInfo.is_use == 1) {
            this.$message.warning('已核销不支持编辑')
            this.clickCount = 0;
            return;
          }

          this.isAdd = !extendId;
          if (extendInfo && extendInfo.is_use !== undefined) {
            this.appointForm = {
              shop_person_id: extendInfo?.appoint_persons?.[0]?.shop_person_id,
              appointDate: extendInfo?.appoint_date_str,
              startTime: extendInfo?.appoint_time_start_str,
              endTime: extendInfo?.appoint_time_end_str_original,
              remark: extendInfo?.remark,
              customer_id: parseInt(extendInfo?.customer_id),
              customer_name: extendInfo?.customer_name,
              in_store: extendInfo?.in_store == '已到店' ? 1 : 0,
            }
          } else {
            this.remarkForm = {
              person_id: extendInfo?.appoint_persons?.[0]?.shop_person_id,
              remarkDate: extendInfo?.appoint_date_str,
              time_start: extendInfo?.appoint_time_start_str,
              time_end: extendInfo?.appoint_time_end_str,
              remark: extendInfo?.remark,
              type: parseInt(extendInfo?.type),
              customer_id: parseInt(extendInfo?.customer_id),
            }
          }
          this.$nextTick(() => { 
            this.dialogAppointVisible = true;
          });
        }
        this.clickCount = 0;
      }, 300);

      if (this.clickCount === 2) {
        clearTimeout(this.clickTimer);
        this.clickCount = 0;
        const targetId = info?.event?._def?.extendedProps?.extendInfo?.customer_id;
        if (!targetId) return;
        let query = {
          id: targetId,
          activeName: "first",
          pageName: "客户列表",
        }
        let route = this.$router.resolve({ name: "客户详情", query: query });
        window.open(route.href, '_blank');
      }
    },
    
    cancelNotice() {
      this.$confirm('确定要删除此备注？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelNotice({
          id: this.customerDetail.id,
          delete_id: this.userInfo.id,
        }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '取消预约成功!'
            });
            this.dialogAppointVisible = false;
            this.fetchAppointData();
            this.$nextTick(() => {
              this.handleExpiredSlotStyle();
            });
          } else {
            this.$message({
              type: 'error',
              message: res.data.error
            });
          }
        });
      }).catch((err) => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },

    cancelBook() {
      this.$confirm('确定要取消此预约记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelBook({
          bookId: this.customerDetail.id,
          person: this.customerDetail.customer_id,
          platform: 2,
          today: this.customerDetail.appoint_date_str.replace(/-/g, ''),
          yy_date: this.customerDetail.appoint_date_str,
          yy_time: this.customerDetail.yy_time_str
        }).then(res => {
          if (res.data.error == '取消成功') {
            this.$message({
              type: 'success',
              message: '取消预约成功!'
            });
            this.dialogAppointVisible = false;
            this.fetchAppointData();
            this.$nextTick(() => {
              this.handleExpiredSlotStyle();
            });
          } else {
            this.$message({
              type: 'error',
              message: res.data.error
            });
          }
        });
      }).catch((err) => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },

   handleEventDidMount(info) {
      if (this.isDragging) return;
      const el = info.el;
      const eventStart = new Date(info.event.start)
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      if (eventStart < today) {
        el.classList.add('event-past')
      } else if (eventStart.toDateString() === today.toDateString()) {
        el.classList.add(DateUtils.isPastTime(eventStart) ? 'event-today-past' : 'event-today-future')
      } else {
        el.classList.add('event-future')
      }

      const currentView = info.view.type;
      const event = info.event;
      const extendedProps = event.extendedProps || {};
      const extendInfo = extendedProps.extendInfo || {};
      const titleEl = el.querySelector('.fc-event-title') || el.querySelector('.fc-event-main');
      
      if (titleEl) {
        titleEl.style = '';
        if (currentView === 'dayGridMonth') {
          titleEl.style.display = 'inline-block';
          titleEl.style.maxWidth = '100%';
          titleEl.style.whiteSpace = 'nowrap';
          titleEl.style.overflow = 'hidden';
          titleEl.style.textOverflow = 'ellipsis';
          titleEl.style.lineHeight = '1.4';
        } else {
          titleEl.style.whiteSpace = 'pre-line';
          titleEl.style.lineHeight = '1.4';
          titleEl.style.padding = '2px 4px';
        }

        if (!extendInfo || !Object.keys(extendInfo).length) return;
        
        // 判断是否为预测数据
        const isPredict = extendedProps.isPredict || extendInfo.is_predict;
        
        let popoverHtml1;
        if (isPredict && extendInfo.is_aggregated) {
          // 聚合预测：列出全部顾客
          const listHtml = (extendInfo.predictList || []).map((p, i) => `
            <div style="border-top:1px dashed #eee;padding-top:6px;margin-top:6px;">
              <div class="detail-item"><label>${i + 1}. 姓名：</label><span>${p.customer_name || '未知'}（${p.telephone || '无'}）</span></div>
              <div class="detail-item"><label>会员等级：</label><span>${p.membership_leve_name || '无'}</span></div>
              <div class="detail-item"><label>治疗进展：</label><span>${p.repair_progress_name || '未知'}</span></div>
              <div class="detail-item"><label>最近到店：</label><span>${p.visit_times && p.visit_times.length > 0 ? p.visit_times : '无'}</span></div>
            </div>
          `).join('');
          popoverHtml1 = `
            <div id="popover-${event.id}" class="el-popover el-popper placement-top-start" style="display: none; z-index: 9999; width: 300px; max-height: 420px; overflow-y: auto;">
              <div class="el-popover__title">预测详情（共${extendInfo.predictList.length}人）</div>
              <div class="el-popover__content">
                <div class="detail-item"><label>预测时间：</label><span>${extendInfo.appoint_date_str || ''} ${extendInfo.appoint_time_start_str || ''}-${extendInfo.appoint_time_end_str || ''}</span></div>
                <div class="detail-item"><label>护理师：</label><span>${extendInfo.appoint_persons?.[0]?.name || '未知'}</span></div>
                ${listHtml}
              </div>
              <div class="el-popover__arrow"></div>
              <div class="el-popover__arrow el-popover__arrow--inner"></div>
            </div>
          `;
        } else {
          // 原来的单条 popoverHtml1
          popoverHtml1 = `
            <div id="popover-${event.id}" class="el-popover el-popper placement-top-start" style="display: none; z-index: 9999; width: 300px;">
              <div class="el-popover__title">${isPredict ? '预测详情' : '预约详情'}</div>
              <div class="el-popover__content">
                <div class="detail-item"><label>姓名：</label><span>${extendInfo.customer_name || '未知'}（${extendInfo.telephone || '无'}）</span></div>
                <div class="detail-item"><label>会员等级：</label><span>${extendInfo.membership_leve_name || '无'} <span>${extendInfo.be_overdue_time ? ` (${extendInfo.be_overdue_time}到期）` : ''} </span></span></div>
                <div class="detail-item"><label>客户分类：</label><span>${extendInfo.class_name ? ` ${extendInfo.class_name}类` : '无'} </span></div>
                <div class="detail-item"><label>治疗进展：</label><span>${extendInfo.repair_progress_name || '未知'}</span></div>
                <div class="detail-item"><label>是否到店：</label><span>${extendInfo.in_store}</span></div>
                <div class="detail-item">
                  <label>${isPredict ? '预测时间：' : '预约时间：'}</label>
                  <span>${extendInfo.appoint_date_str || ''} ${extendInfo.appoint_time_start_str || ''}-${extendInfo.appoint_time_end_str || ''}</span>
                </div>
                <div class="detail-item"><label>最近到店时间：</label><span>${extendInfo.visit_times?.length > 0 ? extendInfo.visit_times : '无'} </span></div>
                <div class="detail-item"><label>护理师：</label><span>${extendInfo.appoint_persons?.[0]?.name || '未知'}</span></div>
                ${!isPredict ? `<div class="detail-item"><label>备注：</label><span>${extendInfo.remark || '无'}</span></div>` : ''}
                ${!isPredict ? `<div class="detail-item"><label>添加方式：</label><span>${extendInfo.type_text || '无'}</span></div>` : ''}
              </div>
              <div class="el-popover__arrow"></div>
              <div class="el-popover__arrow el-popover__arrow--inner"></div>
            </div>
          `;
        }
        const popoverHtml = `
          <div id="popover-${event.id}" class="el-popover el-popper placement-top-start" style="display: none; z-index: 9999; width: 300px;">
            <div class="el-popover__title">备注详情</div>
            <div class="el-popover__content">
              <div class="detail-item"><label>备注：</label><span>${extendInfo.remark || '无'}</span></div>
              <div class="detail-item"><label>所属时间：</label><span>${extendInfo.appoint_date_str || ''} ${extendInfo.appoint_time_start_str || ''}-${extendInfo.appoint_time_end_str || ''}</span></div>
              <div class="detail-item"><label>所属护理师：</label><span>${extendInfo.appoint_persons?.[0]?.name || '未知'}</span></div>
              <div class="detail-item"><label>添加人：</label><span>${extendInfo.create_name || '未知'}</span></div>
              <div class="detail-item"><label>是否发送：</label><span>${extendInfo.is_send === 0 ? '是未发送' : extendInfo.is_send === 1 ? '已发送' : '发送失败'}</span></div>
              <div class="detail-item"><label>备注类型：</label><span>${extendInfo.type === 1 ? '个人通知' : '店铺通知'}</span></div>
            </div>
            <div class="el-popover__arrow"></div>
            <div class="el-popover__arrow el-popover__arrow--inner"></div>
          </div>
        `;
        try {
          const popoverEl = document.createElement('div');
          popoverEl.innerHTML = extendInfo.notic == true ? popoverHtml : popoverHtml1;
          const popover = popoverEl.firstElementChild;
          if (!popover) return;

          document.body.appendChild(popover);

          el.addEventListener('mouseenter', () => {
            if (this.isDragging) return;

            const rect = el.getBoundingClientRect();
            popover.style.top = `${rect.bottom - 150}px`;
            popover.style.left = `${rect.left - 330}px`;
            popover.classList.remove('placement-top-start');
            popover.classList.add('placement-bottom-start');
            popover.style.display = 'block';
            setTimeout(() => {
              popover.style.opacity = '1';
              popover.style.transform = 'translateY(0)';
            }, 10);
          });

          el.addEventListener('mouseleave', () => {
            if (this.isDragging) {
              popover.style.display = 'none';
              return;
            }
            popover.style.opacity = '0';
            popover.style.transform = 'translateY(-8px)';
            setTimeout(() => {
              popover.style.display = 'none';
            }, 200);
          });

          this.$once('hook:beforeDestroy', () => {
            const popover = document.querySelector(`#popover-${event.id}`);
            if (popover) popover.remove();
          });
        } catch (error) {
          console.error('创建Popover失败：', error);
          return;
        }
      }
    },

    handleDateSearch() {
      if (!this.selectedDate) {
        this.$message.warning('请选择要搜索的日期！')
        return
      }
      this.searchForm.start_time = this.selectedDate
      this.searchForm.end_time = this.selectedDate

      const calendarApi = this.$refs.fullCalendar?.getApi()
      if (calendarApi) {
        calendarApi.gotoDate(this.selectedDate)
      }
      this.$nextTick(() => {
        this.handleExpiredSlotStyle();
      });
    },

    disabledPastDate(date) {
      return DateUtils.isPastDate(date, true)
    },

    handleCalendarSelect(info) {
      const selectedDate = DateUtils.formatYmd(info.start)
      const startTime = DateUtils.formatHm(info.start)
      const endTime = DateUtils.formatHm(info.end)
      const shop_person_id = info.resource?.id 

      this.appointForm = {
        ...this.appointForm,
        appointDate: selectedDate,
        startTime: startTime === '00:00' ? '' : startTime,
        endTime: endTime === '00:00' ? '' : endTime,
        shop_person_id: parseInt(shop_person_id) || ''
      }
      this.remarkForm = {
        ...this.remarkForm,
        remarkDate: selectedDate,
        time_start: startTime === '00:00' ? '' : startTime,
        time_end: endTime === '00:00' ? '' : endTime,
        person_id: parseInt(shop_person_id) || ''
      }
      this.activeTab = 'first'
      this.dialogAppointVisible = true
      this.$nextTick(() => {
        this.$refs.appointFormRef?.clearValidate()
        this.$refs.remarkFormRef?.clearValidate()
      })
    },

    handleTabClick(tab) {
      this.activeTab = tab.name
    },

    handleDialogClose() {
      this.appointForm = {
        appointDate: '',
        startTime: '',
        endTime: '',
        customer_id: '',
        customer_name: '',
        patientPhone: '',
        shop_person_id: '',
        remark: '',
        in_store: '',
      }
      this.remarkForm = {
        remark: '',
        time_end: '',
        time_start: '',
        shop_id: '',
        person_id: '',
        create_id: '',  
        remarkDate: '',
        type: '',
      }
      this.isAdd = true
      this.dialogAppointVisible = false
      if (this.$refs.appointFormRef) this.$refs.appointFormRef.resetFields();
      if (this.$refs.remarkFormRef) this.$refs.remarkFormRef.resetFields();
    }
  },
  beforeDestroy() {
    clearTimeout(this.clickTimer);
    this.isDragging = false;
    this.dragOriginalEvent = null;
    document.querySelectorAll('[id^="popover-"]').forEach(el => el.remove());
  }
}
</script>

<style scoped lang="scss">
.status-tag {
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
  color: #333333;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
}

.color-block {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 8px;
}

.status-text {
  font-weight: 500;
}

::v-deep .el-dialog__body {
  padding-top: 0;
}

.appointment-calendar-container {
  padding: 20px;
}

.calendar-header {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
}

.date-picker {
  width: 200px;
}

.search-btn, .add-appoint-btn {
  white-space: nowrap;
}

.calendar-body {
  width: 100%;
}

.demo-app-calendar {
  min-height: 600px;
  width: 100%;
}

.table_box {
  margin: 20px auto;
  text-align: center;
  color: red;
  line-height: 20px;
  width: 60%;
  cursor: pointer;
}

.table_tile {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #000;
}
</style>

<style lang="scss">
.fc .fc-button-primary {
  background-color: #33bea7 !important;
  border-color: #33bea7 !important;
  &:hover {
    background: none !important;
    color: #33bea7 !important;
  }
}
.fc .fc-button-primary:not(:disabled):active:focus, .fc .fc-button-primary:not(:disabled).fc-button-active:focus {
  box-shadow: none !important;
}
.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child) {
  box-shadow: none !important;
}
.fc .fc-button-primary:not(:disabled):active, .fc .fc-button-primary:not(:disabled).fc-button-active {
  background-color: rgba(51, 190, 167, 0.6) !important;
  border-color: #33bea7 !important;
  color: #fff !important;
}

.fc {
  --fc-border-color: #e6e6e6;
  --fc-daygrid-event-bg-color: transparent;
}

.fc th {
  background: #eff0f2 !important;
  line-height: 30px;
}

.fc table tr {
  height: 35px;
}

.fc-header-toolbar {
  font-size: 11px !important;
}

.fc-day-today {
  background-color: #fff !important;
}

.fc-resourceTimeGridDay-view .fc-slot-today-expired {
  background-color: rgba(217, 236, 255, 0.7) !important;
  color: #999 !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}

.fc-timegrid-event .fc-event-main {
  color: #1f1f1f;
  padding: 2px 4px;
}

// 预测事件紧凑样式
.fc-timegrid-event.event-predict-compact {
  min-height: 20px !important;
  font-size: 11px !important;
  line-height: 1.3 !important;
  margin: 1px 0 !important;
  
  .fc-event-main {
    padding: 1px 4px !important;
    font-size: 11px !important;
  }
  
  .fc-event-time {
    font-size: 10px !important;
  }
}

.fc-dayGridMonth-view .fc-daygrid-event {
  display: block !important;
  background-color: inherit !important;
  border: none !important;
  padding: 4px 6px !important;
  margin: 2px 0 !important;
  border-radius: 2px !important;
  width: calc(100% - 4px) !important;
  box-sizing: border-box !important;
}

.fc-dayGridMonth-view .event-status-3 {
  background-color: #fff2e1 !important;
}

.fc-dayGridMonth-view .event-status-7 {
  background-color: #f3ffed !important;
}

.fc-dayGridMonth-view .event-status-5 {
  background-color: #faeaea !important;
}

.fc-dayGridMonth-view .event-predict {
  background-color: #FBFDFF !important;
  border-left: 3px solid #4d94ff !important;
}

.fc-event.event-status-7 {
  border: none !important;
  border-left: 4px solid #90cb73 !important;
}

.fc-event.event-status-3 {
  border: none !important;
  border-left: 4px solid #ffad48 !important;
}

.fc-event.event-status-6 {
  border: none !important;
  border-left: 4px solid #fff143 !important;
}

.fc-event.event-status-5 {
  border: none !important;
  border-left: 4px solid #ff7676 !important;
}

.fc-event.event-predict {
  border: 1px solid #b8d9f0 !important;
  background-color: #FBFDFF !important;
  width: 75% !important;
}

.slot-remark-content {
  position: absolute;
  top: 2px;
  left: 2px;
  font-size: 12px;
  color: #666;
  max-width: calc(100% - 10px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 5;
}

.fc-event-time {
  font-size: 12px;
  color: #999;
}

.fc-resource-area {
  border-right: 1px solid #e6e6e6;
}

.fc-resource-cell {
  padding: 4px 8px;
  border-bottom: 1px solid #e6e6e6;
}
</style>

<style scoped lang="scss">
::v-deep .fc-license-message {
  display: none !important;
  background: #f5f5f5 !important;
  font-size: 11px !important;
  color: #999 !important;
  padding: 1px 2px !important;
  border: none !important;
}
</style>